import React from 'react'
import { makeStyles } from '@mui/styles'

import lang from '@/lang'
import ThemeInterface from '@/theme-interface'

const useStyles = makeStyles((theme: ThemeInterface) => ({
  title: {
    fontWeight: theme.fontWeights.medium,
    color: theme.text,
  },
  description: {
    fontWeight: theme.fontWeights.regular,
    fontSize: theme.fontSizes.smaller,
    color: theme.text,
    letterSpacing: 0,
  },
  itemsTitle: {
    marginTop: 20,
    fontSize: theme.fontSizes.smedium,
    fontWeight: theme.fontWeights.medium,
    fontFamily: theme.fontFamily,
  },
  item: {
    display: 'flex',
    flexDirection: 'column',
    fontFamily: theme.fontFamily,
    color: theme.text,
    marginTop: 5,
    '&:last-of-type': {
      marginTop: 15,
    },
  },
  itemTitle: {
    fontWeight: theme.fontWeights.medium,
    fontSize: theme.fontSizes.small,
  },
  itemDescription: {
    fontSize: theme.fontSizes.smaller,
    fontWeight: theme.fontWeights.regular,
    lineHeight: '16px',
  },
}))

const ReceiptAnalyseResultTooltip = React.memo(() => {
  const classes = useStyles()

  return (
    <div>
      <div className={classes.title}>{lang.receipt.analyseResult.tooltip.title}</div>
      <div className={classes.description}>{lang.receipt.analyseResult.tooltip.description}</div>
      <div className={classes.itemsTitle}>{lang.receipt.analyseResult.tooltip.items.title}</div>
      <div className={classes.item}>
        <div className={classes.itemTitle}>{lang.receipt.analyseResult.tooltip.items.valid.title}</div>
        <div
          className={classes.itemDescription}
          dangerouslySetInnerHTML={{ __html: lang.receipt.analyseResult.tooltip.items.valid.description }}>
        </div>
      </div>
      <div className={classes.item}>
        <div className={classes.itemTitle}>{lang.receipt.analyseResult.tooltip.items.invalid.title}</div>
        <div
          className={classes.itemDescription}
          dangerouslySetInnerHTML={{ __html: lang.receipt.analyseResult.tooltip.items.invalid.description }}>
        </div>
      </div>
    </div>
  )
})

export default ReceiptAnalyseResultTooltip
